/*
 * VQ Treuepunkte-Badge (PDP)
 * Aktualisiert die angezeigten Punkte, wenn auf der Produktseite die Variante
 * gewechselt wird. Nutzt das Theme-Pub/Sub-Event PUB_SUB_EVENTS.variantChange.
 * Punkte = abgerundete volle Euro des Variantenpreises * Rate (Punkte pro Euro).
 */
if (!customElements.get('loyalty-points-badge')) {
  customElements.define(
    'loyalty-points-badge',
    class LoyaltyPointsBadge extends HTMLElement {
      connectedCallback() {
        this.rate = parseFloat(this.dataset.rate) || 1;
        this.numEl = this.querySelector('[data-lb-points]');

        if (
          typeof subscribe === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' &&
          PUB_SUB_EVENTS.variantChange
        ) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event && event.data && event.data.variant;
            if (!variant || typeof variant.price !== 'number') return;
            this.updatePoints(variant.price);
          });
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      updatePoints(priceInCents) {
        if (!this.numEl) return;
        const points = Math.floor(priceInCents / 100) * this.rate;
        this.numEl.textContent = points;
      }
    }
  );
}
